var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6312 33.2624C26.9211 33.2624 33.7651 26.409 33.7651 18.1311C33.7651 9.84128 26.9091 2.99988 18.6192 2.99988C10.344 2.99988 3.5 9.84128 3.5 18.1311C3.5 26.409 10.356 33.2624 18.6312 33.2624Z",
    fill: "#389E0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9987 25.3628C16.4479 25.3628 15.9956 25.1234 15.5857 24.5923L11.996 20.2255C11.7341 19.8904 11.5996 19.5523 11.5996 19.1812C11.5996 18.4349 12.1914 17.8297 12.9349 17.8297C13.3993 17.8297 13.7506 17.9853 14.1273 18.4687L16.9507 22.0534L23.0078 12.3553C23.3257 11.8552 23.7408 11.5918 24.1902 11.5918C24.9218 11.5918 25.5936 12.1051 25.5936 12.8726C25.5936 13.2107 25.4163 13.5687 25.2116 13.9054L18.3584 24.5818C18.0218 25.0942 17.5468 25.3628 16.9987 25.3628Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkSuccessful);
export default __webpack_public_path__ + "static/media/checkmark_successful.c897365b000d5d13478f2b48371a67a6.svg";
export { ForwardRef as ReactComponent };